import { ActionButton } from '../../components/vertical-dot/popper';

export const brokerSsoKeyManagementHeader = ({
  actions,
  tableActions,
}: {
  actions?: any;
  tableActions?: any;
}): any[] => {
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        const actions = tableActions;

        return (
          <td>
            <ActionButton
              actions={actions}
              id={row.original.id}
              rowData={row.original}
              counter={parseInt(row?.id)}
              renderPopoverInPortal={true}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
};
